import './HistoryChart.less';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { AppLocaleProvider } from 'sd-ui-components';
import './HistoryChart.less';

const { injectIntl } = AppLocaleProvider;

@inject('SafetyStore')
@observer
class CustomizedLegend extends React.Component {
  render() {
    return (
      <g>
        <TargetLegend
          viewBox={this.props.viewBox}
          targetScore={this.props.SafetyStore.safetyData.targetScore}
        />
        {this.props.doesChartHaveNullScores && (
          <NotEnoughDataLegend
            viewBox={this.props.viewBox}
            targetScore={this.props.SafetyStore.safetyData.targetScore}
          />
        )}
      </g>
    );
  }
}

let counter = 0;

const TargetLegend = injectIntl(props => {
  const { viewBox, targetScore } = props;
  if (!targetScore) {
    return null;
  }

  return (
    <g>
      <line
        id={`sd-ui-driver-safety-history-target-legend-${counter++}`}
        x1={viewBox.x - 20}
        y1={viewBox.y + 45}
        x2={viewBox.x + 35}
        y2={viewBox.y + 45}
        className="safety-chart-legend-target-line"
      />
      <text
        id={`sd-ui-driver-safety-history-target-legend-${counter++}`}
        x={viewBox.x + 55}
        y={viewBox.y + 45}
        width={120}
        height={50}
        className="safety-chart-legend-text"
      >
        {props.intl.formatMessage({
          id: 'App.Safety.Target',
          defaultMessage: 'Target'
        })}
      </text>
    </g>
  );
});

const NotEnoughDataLegend = injectIntl(props => {
  const { viewBox } = props;

  return (
    <g>
      <line
        id={`sd-ui-driver-safety-history-no-data-legend-${counter++}`}
        x1={viewBox.x + 100}
        y1={viewBox.y + 45}
        x2={viewBox.x + 150}
        y2={viewBox.y + 45}
        className="safety-chart-legend-no-data-line"
      />
      <text
        id={`sd-ui-driver-safety-history-no-data-legend-${counter++}`}
        x={viewBox.x + 225}
        y={viewBox.y + 45}
        width={120}
        height={50}
        className="safety-chart-legend-text"
      >
        {props.intl.formatMessage({
          id: 'App.Safety.NotEnoughData',
          defaultMessage: 'Not enough data available.'
        })}
      </text>
    </g>
  );
});

export default CustomizedLegend;



// WEBPACK FOOTER //
// ./src/containers/Safety/HistoryChart/CustomizedLegend.jsx